import { Component, ElementRef, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild } from '@angular/core';

@Component({
  selector: 'app-repricing-price-editor',
  templateUrl: './repricing-price-editor.component.html',
  styleUrls: ['./repricing-price-editor.component.scss']
})
export class RepricingPriceEditorComponent implements OnChanges {
  @Input() displayCurrency: any;
  @Input() label: string = 'Your Price';
  @Input() labelClass: string = 'label label-medium d-flex align-items-center gap-2 mb-1';
  @Input() priceClass: string = '';
  @Input() isExceedRange: boolean = false;
  @Input() customPrice: number;
  @Input() targetPrice: number;
  @Input() trendPercentage: number = 0;
  @Input() effectiveTrend: number = 0;
  @Input() validationError: string;
  @Input() isEditing: boolean = false;
  @Input() isReadOnly: boolean = false;
  @Input() isMissingPrice: boolean = false;
  @Input() showTrendBadge: boolean = true;
  @Input() showSuggestedPrice: boolean = true;
  @Input() nullPlaceholder: string = '';

  @Output() customPriceChange = new EventEmitter<number>();
  @Output() resetPrice = new EventEmitter<void>();
  @Output() editToggled = new EventEmitter<void>();
  @Output() priceCommitted = new EventEmitter<void>();

  @ViewChild('priceInput') private priceInputRef!: ElementRef<HTMLInputElement>;

  private readonly FOCUS_DELAY_MS = 0;

  ngOnChanges(changes: SimpleChanges): void {
    const editingTurnedOn = changes['isEditing']?.currentValue === true
      && changes['isEditing']?.previousValue !== true;

    if (editingTurnedOn && this.isMissingPrice) {
      setTimeout(() => this.priceInputRef?.nativeElement?.focus(), this.FOCUS_DELAY_MS);
    }
  }

  get isCustomPriceActive(): boolean {
    return this.customPrice != null && this.customPrice !== this.targetPrice;
  }

  onPriceChange(value: number) {
    this.customPriceChange.emit(value);
  }

  onReset() {
    this.resetPrice.emit();
  }

  onEditToggle(inputElement: HTMLInputElement) {
    this.editToggled.emit();

    setTimeout(() => inputElement.focus(), 0);
  }

  onBlur() {
    if (this.validationError) return;
    this.priceCommitted.emit();
  }
}
